import { useQuery } from '@tanstack/react-query';
import useAPI from 'services/useAPI';

// general structure of the query keys that should probably work for most cases
export const timeseriesKeys = {
  all: ['timeseries'],
  timeseries: () => [...timeseriesKeys.all],
  timeseriesWithKeys: (keys) => [...timeseriesKeys.timeseries(), keys]
};

export const useTimeseriesQuery = (keys, signals, timespan, interval, enabled) => {
  const api = useAPI();
  const userQuery = useQuery({
    queryKey: timeseriesKeys.timeseriesWithKeys(keys),
    queryFn: ({ signal }) => {
      return api.core.getAssetsTimeSeries(signal, signals, timespan, interval);
    },
    enabled: enabled
  });
  return userQuery;
};
